var map = {
	"./fig01.jpg": "df60",
	"./fig02.jpg": "1c6c",
	"./fig03.jpg": "8a8d",
	"./fig04.jpg": "d203",
	"./fig05.jpg": "50bd",
	"./fig06.jpg": "ab64",
	"./fig07.jpg": "9817",
	"./fig08.jpg": "c7ec",
	"./fig09.jpg": "3740",
	"./fig10.jpg": "e0dd",
	"./fig11.jpg": "eeec",
	"./fig12.jpg": "05f8",
	"./fig13.jpg": "1814",
	"./fig14.jpg": "e441"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "51ea";